// extracted by mini-css-extract-plugin
module.exports = {"Emoji":"bba_a bhb_i bhb_q bhb_j"};